"use strict";
const v8Formatter = {
  v8Forms: document.querySelectorAll(".v8Form__form"),
  init: function () {
    for (let e of this.v8Forms) {
      let t = e.querySelectorAll("[data-logic]");
      this.showConditionalFields(t, e), this.customRadio(e);
      let i = e.querySelector('input[type="tel"]');
      i.addEventListener("keyup", this.formatPhoneField(i)),
        this.addInlineCalendar(e),
        this.formatFileUpload(e);
      let l = e.querySelector(".v8-zip-lookup > input");
      if (l) {
        let a = document.querySelector(".v8Form__bottom-nav");
        a && (a.style.display = "none"),
          l.addEventListener("input", (e) => this.lookupZipCode(l));
      }
    }
    this.getReferrer();
  },
  lookupZipCode: async function (e) {
    let t = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    t &&
      "geolocation" in navigator &&
      e &&
      window.addEventListener("load", () => {
        confirm(
          "Would you like to share your location to automatically detect your zip code?",
        )
          ? navigator.geolocation.getCurrentPosition(
              async (t) => {
                let { latitude: i, longitude: l } = t.coords;
                console.log("Latitude: ", i, "Longitude: ", l);
                try {
                  let a = await fetch(
                      `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${i}&longitude=${l}&localityLanguage=en`,
                    ),
                    n = await a.json(),
                    r = n.postcode || n.localityInfo.administrative[0].isoName;
                  if (r)
                    (e.value = r),
                      console.log("Auto-detected ZIP Code: ", r),
                      e.dispatchEvent(new Event("change"));
                  else {
                    console.error("Unable to detect zip code from location.");
                    return;
                  }
                } catch (d) {
                  console.error(
                    "Error during geolocation or reverse geocoding: ",
                    d,
                  );
                  return;
                }
              },
              (e) => {
                console.warn(`Geolocation Error (${e.code}): ${e.message}`);
              },
            )
          : console.log("Geolocation denied by the user.");
      });
    let i = e.value.trim(),
      l = document.querySelector(".v8Form__bottom-nav");
    if ((l && (l.style.display = "none"), i.length < 5)) return;
    if (!/^(\d{5}(?:-\d{4})?)|([A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d)$/.test(i)) {
      console.warn("Invalid ZIP or Postal Code.");
      let a = document.createElement("div");
      a.classList.add("v8-fail-message"),
        (a.innerHTML =
          "<strong>Error!</strong> Please enter a valid ZIP or Postal Code."),
        e.parentElement.insertBefore(a, e.parentElement.firstChild),
        l && (l.style.display = "none");
      return;
    }
    console.log("Looking up ZIP or Postal Code:", i);
    let n = document.createElement("div");
    n.classList.add("v8-spinner"),
      (n.innerHTML =
        '<div class="v8-spinner-container"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>');
    let r = document.querySelector(".v8Form");
    r ? r.appendChild(n) : e.parentElement.appendChild(n);
    try {
      let d = await fetch(
          `${wpRest.siteUrl}/wp-content/plugins/lnb-v8-scheduler/src/api/st-zip-lookup.php?frontEndLookup=true&zip=${encodeURIComponent(i)}`,
        ),
        s = await d.json();
      if (
        (e.parentElement
          .querySelectorAll(".v8-success-message, .v8-fail-message")
          .forEach((e) => e.remove()),
        d.ok && "success" === s.status)
      ) {
        console.log("Service zones data received:", s);
        let o = document.createElement("div");
        o.classList.add("v8-success-message"),
          (o.innerHTML = `<strong>Success!</strong> ${s.message}`),
          e.parentElement.insertBefore(o, e.parentElement.firstChild),
          l && (l.style.display = "block");
      } else {
        console.log("Service is not available or unexpected response format.");
        let c = document.createElement("div");
        c.classList.add("v8-fail-message"),
          (c.innerHTML =
            "<strong>Sorry!</strong> Service is not available in this area. Please try another ZIP or Postal Code."),
          e.parentElement.insertBefore(c, e.parentElement.firstChild),
          l && (l.style.display = "none");
      }
    } catch (v) {
      console.error("Error during zip code lookup:", v);
      let u = document.createElement("div");
      u.classList.add("v8-fail-message"),
        (u.innerHTML =
          "<strong>Error!</strong> Unable to perform the lookup at the moment."),
        e.parentElement.insertBefore(u, e.parentElement.firstChild);
    } finally {
      n.remove();
    }
  },
  formatPhoneField: (e, t) =>
    async function (t) {
      if (!e.value) return e.value;
      let i = e.value.replace(/\D/g, "").match(/^(\d{3})(\d{3})(\d{4})$/);
      if (i) {
        t.target.value = `(${i[1]}) ${i[2]}-${i[3]}`;
        let l = e.closest(".v8-cust-lookup");
        if (l) {
          console.log(
            "Triggering ServiceTitan lookup for phone number:",
            i[1] + i[2] + i[3],
          );
          let a = i[1] + i[2] + i[3],
            n = document.createElement("div"),
            r = document.createElement("div"),
            d = document.createElement("div");
          n.classList.add("v8-spinner"),
            (n.innerHTML =
              '<div class="v8-spinner-container"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>');
          let s = document.querySelector(".v8Form");
          s ? s.appendChild(n) : l.appendChild(n);
          try {
            let o = await fetch(
                `${wpRest.siteUrl}/wp-content/plugins/lnb-v8-scheduler/src/api/st-cust-lookup.php?frontEndLookup=true&phone=${a}`,
              ),
              c = await o.json(),
              v = l.querySelector(".v8-fail-message"),
              u = l.querySelector(".v8-success-message");
            v && v.remove(), u && u.remove();
            let p = document.querySelector(".v8Form__returning");
            if (o.ok && c && c.data && c.data.length > 0) {
              console.log("Customer data received:", c),
                p && (p.value = "true");
              let m = (e, t) => e.substring(0, t) + "****";
              if (c.data.length > 1) {
                let _ = document.createElement("div");
                _.classList.add("v8-address-modal");
                let f = document.createElement("div");
                f.classList.add("v8-address-modal-content"),
                  (f.innerHTML = "<h2>Select Your Service Address</h2>");
                let $ = document.createElement("ul");
                $.classList.add("v8-address-list"),
                  c.data.forEach((e) => {
                    let t = document.createElement("li"),
                      i = m(e.name, 3),
                      l = m(e.address.street, 7);
                    (t.innerHTML = `${i}, ${l}, ${e.address.zip}`),
                      t.addEventListener("click", () => {
                        let t = document.getElementById("given-name"),
                          i = document.getElementById("family-name"),
                          l = document.getElementById("address1"),
                          a = document.getElementById("address2"),
                          n = document.getElementById("city"),
                          r = document.getElementById("zip");
                        if (t && i) {
                          let d = e.name.split(" ");
                          (t.value = d[0]),
                            (i.value = d.length > 1 ? d[d.length - 1] : "");
                        }
                        l && (l.value = e.address.street),
                          a && (a.value = e.address.unit || ""),
                          n && (n.value = e.address.city),
                          r && (r.value = e.address.zip),
                          _.remove();
                      }),
                      $.appendChild(t);
                  }),
                  f.appendChild($);
                let h = document.createElement("button");
                (h.innerText = "Close"),
                  h.classList.add("v8-modal-close"),
                  h.addEventListener("click", () => _.remove()),
                  f.appendChild(h),
                  _.appendChild(f),
                  document.body.appendChild(_);
              } else {
                let y = c.data[0];
                r.classList.add("v8-success-message"),
                  (r.innerHTML =
                    "<strong>Congratulations!</strong> We found your information in our system. Please review and confirm."),
                  l.insertBefore(r, l.firstChild);
                let g = document.getElementById("given-name"),
                  E = document.getElementById("family-name"),
                  L = document.getElementById("address1"),
                  S = document.getElementById("address2"),
                  C = document.getElementById("city"),
                  k = document.getElementById("zip");
                g && (g.value = y.name.split(" ")[0]),
                  E && (E.value = y.name.split(" ").slice(-1)[0]),
                  L && (L.value = y.address.street),
                  S && (S.value = y.address.unit || ""),
                  C && (C.value = y.address.city),
                  k && (k.value = y.address.zip);
              }
            } else
              console.log(
                "No customer data found, form can be filled manually.",
              ),
                p && (p.value = "false"),
                d.classList.add("v8-fail-message"),
                (d.innerHTML =
                  "<strong>Oops! We didn’t find a match for that phone number.</strong> No problem! You can try another number, or simply continue filling out the form below — it only takes a sec!"),
                l.insertBefore(d, l.firstChild);
          } catch (b) {
            console.error("Error during customer lookup:", b);
          } finally {
            n.remove();
          }
        }
      }
      return null;
    },
  showConditionalFields(e, t) {
    for (let i of e) {
      i.style.display = "none";
      let l = i.dataset.logic.split("-"),
        a = t.querySelector(`[name="input_${l[0]}"]`),
        n = a.parentElement.parentElement.querySelector(`[value="${l[2]}"]`);
      "checkbox" === a.type &&
        n.addEventListener("change", function (e) {
          this.checked
            ? (i.style.display = "inline-block")
            : (i.style.display = "none");
        }),
        "radio" === a.type &&
          n.addEventListener("change", function (e) {
            a.parentElement.querySelector("input[type=radio]:checked"),
              n.checked
                ? (i.style.display = "inline-block")
                : (i.style.display = "none");
          });
    }
  },
  customRadio: function (e) {
    e.addEventListener("click", function (e) {
      if (e.target.classList.contains("v8Fields__radio-single")) {
        for (let t of e.target.parentElement.children)
          t.classList.remove("v8-radio-selected"),
            (t.querySelector("input").checked = !1);
        e.target.classList.add("v8-radio-selected"),
          (e.target.querySelector("input").checked = !0);
      }
    });
  },
  formatFileUpload: function (e) {
    let t = e.querySelectorAll('input[type="file"]');
    for (let i of t) {
      let l = new FileReader(),
        a = i.parentElement.querySelector(".v8Fields__fileupload-preview"),
        n = i.parentElement.querySelector(
          ".v8Fields__fileupload-preview--close",
        );
      l.addEventListener(
        "load",
        function (e) {
          new Image(), (a.style.backgroundImage = `url(${l.result})`);
        },
        !1,
      ),
        i.addEventListener("change", function (e) {
          if (-1 !== e.target.files[0].type.search("image"))
            l.readAsDataURL(e.target.files[0]);
          else if ("application/pdf" === e.target.files[0].type) {
            let t = document.createElement("fa-icon");
            t.setAttribute("icon", "file-pdf"),
              (t.style.fontSize = "30px"),
              (t.style.textAlign = "center"),
              (t.style.padding = "5% 0"),
              (t.style.display = "inherit"),
              a.appendChild(t);
          }
        }),
        n.addEventListener("click", function (e) {
          (i.value = null), (a.style.backgroundImage = "");
        });
    }
  },
  getReferrer() {
    document.querySelector(".v8__referrer").value = document.referrer;
  },
  addInlineCalendar: function (e) {
    let t = e.querySelector(".v8-inline-calendar > input"),
      i = e.querySelector(".v8-inline-calendar"),
      l = [];

    if (!i || !t) {
      return;
    }

    i.classList.contains("v8-no-weekends")
      ? (l = [0, 6])
      : i.classList.contains("v8-no-sat-only")
        ? (l = [6])
        : i.classList.contains("v8-no-sun-only") && (l = [0]);

  // Determine minDate based on the one-day buffer setting
  let minDate = new Date();
  if (typeof v8Settings !== "undefined" && v8Settings.enableOneDayBuffer) {
    console.log('One-day buffer is enabled');
    minDate.setDate(minDate.getDate() + 1);
  } else {
    console.log('One-day buffer is disabled');
  }

    let a = {
      inline: !0,
      minDate: minDate,
      dateFormat: "Y-m-d",
      allowInput: !0,
      disable: [
        function (e) {
          return l.includes(e.getDay());
        },
      ],
      onChange: async function (t, i, l) {
        let a = e.querySelector("[name=gf_form_id]").value,
        activeBusinessUnit = Array.from(e.querySelectorAll(".v8_business_units select"))
            .find(el => el.offsetParent !== null),
        activeJobType = Array.from(e.querySelectorAll(".v8_job_type select"))
            .find(el => el.offsetParent !== null),
        r = activeBusinessUnit ? activeBusinessUnit.value : null,
        jtv = activeJobType ? activeJobType.value : null;

        // Validate inputs
        if (!r) {
            console.warn("Business Unit ID is missing.");
            // return;
        }
        if (!jtv) {
            console.warn("Job Type Selector is missing or empty.");
            // return;
        }

        if (!e.querySelector(".v8-dynamic-slots")) return;

        let d = await e.querySelector(
            ".v8-dynamic-slots > div > .v8Fields__radio-container",
          ),
          s = document.createElement("div");
          s.classList.add("v8-spinner"),
          (s.innerHTML =
            '<div class="v8-spinner-container"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>');
        let o = document.querySelector(".v8Form");
        o ? o.appendChild(s) : d.appendChild(s),
          console.log("Fetching capacity data for date:", i, " and formId:", a);
        try {
            // Construct the base URL
            let apiUrl = `${wpRest.siteUrl}/wp-content/plugins/lnb-v8-scheduler/src/api/st-cap-lookup.php?frontEndLookup=true&date=${i}&formId=${a}`;

            // Append businessUnitIds if available
            if (r) {
              apiUrl += `&businessUnitIds=${r}`;
            }

            // Append jobTypeId if available
            if (jtv) {
              apiUrl += `&jobTypeId=${jtv}`;
            }

            // Make the fetch request
            let c = await fetch(apiUrl);

          if ((console.log("Raw response from API:", c), !c.ok))
            throw Error(`API request failed with status ${c.status}`);


          let v = await c.json();
          if (v.availabilities && v.availabilities.length > 0) {
            // Filter and aggregate available slots
            let u = v.availabilities
              .filter(slot => slot.isAvailable) // Filter only available slots
              .reduce((acc, slot) => {
                let key = `${slot.start}-${slot.end}`;
                if (!acc[key]) {
                  acc[key] = { ...slot, openAvailability: slot.openAvailability };
                } else {
                  acc[key].openAvailability += slot.openAvailability; // Aggregate openAvailability
                }
                return acc;
              }, {});
          
            let aggregatedSlots = Object.values(u); // Convert to array for iteration
          
            console.log("Aggregated Available Slots:", aggregatedSlots);

            let p = d.querySelector("input").name;
            for (; d.firstChild; ) d.removeChild(d.lastChild);

            for (let m of aggregatedSlots) {
              let _ = new Date(m.start),
                f = new Date(m.end),
                $ = { weekday: "short", year: "numeric", month: "short", day: "numeric" },
                h = _.toLocaleDateString("en-US", $),
                y = { hour: "numeric", minute: "numeric", hour12: !0, timeZone: "UTC" },
                g = _.toLocaleString("en-US", y),
                E = f.toLocaleString("en-US", y),
                L = document.createElement("input");
                
              (L.type = "radio"), (L.value = m.start), (L.name = p);
              let S = document.createElement("span");
              S.innerHTML = `${h}, ${g} - ${E}`;
              console.log(m.openAvailability);
              let C = document.createElement("div");
              C.classList.add("v8Fields__radio-single"),
                0 === m.openAvailability &&
                  (C.classList.add("v8-radio-unavailable"),
                  (C.title = "Time Unavailable")),
                C.appendChild(L),
                C.appendChild(S),
                d.appendChild(C);
            }
          } else
            d.innerHTML =
              'No available time slot <div class="v8-no-calendar"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" fill="none"><path fill="#737475" d="M60 17.016H0V7.889a2.715 2.715 0 0 1 2.707-2.707h54.586A2.715 2.715 0 0 1 60 7.89z"></path><path fill="#DFE0E1" d="M57.293 60.348H2.707A2.715 2.715 0 0 1 0 57.641V17.016h60V57.64a2.703 2.703 0 0 1-2.707 2.707"></path><path fill="#fff" d="M55.94 21.076H4.06v35.212h51.88z"></path><path fill="#BCBCBD" d="M15.12 10.345a5.18 5.18 0 0 1-5.182-5.182C9.938 2.3 12.278 0 15.121 0s5.182 2.32 5.182 5.182h-1.934a3.243 3.243 0 0 0-3.248-3.248 3.243 3.243 0 0 0-3.249 3.248c0 1.798 1.47 3.23 3.249 3.23zM30.01 10.345a5.18 5.18 0 0 1-5.182-5.182C24.828 2.3 27.148 0 30.01 0a5.18 5.18 0 0 1 5.182 5.182h-1.934a3.256 3.256 0 0 0-3.248-3.248 3.243 3.243 0 0 0-3.249 3.248 3.243 3.243 0 0 0 3.249 3.249zM44.879 10.345a5.18 5.18 0 0 1-5.182-5.182C39.697 2.3 42.037 0 44.879 0a5.18 5.18 0 0 1 5.182 5.182h-1.934a3.255 3.255 0 0 0-3.248-3.248 3.255 3.255 0 0 0-3.249 3.248 3.243 3.243 0 0 0 3.249 3.249z"></path><path fill="#949596" d="M55.94 31.692H4.06v1.547h51.88zM55.94 43.99H4.06v1.547h51.88z"></path><path fill="#949596" d="M17.402 21.076h-1.547v35.212h1.547zM30.783 21.076h-1.547v35.212h1.547zM44.144 21.076h-1.547v35.212h1.547z"></path><path fill="#949596" stroke="#949596" stroke-width="0.5" d="m25.804 37.052.177-.176-.177-.177-.501-.502-.177-.176-.177.176L23.147 38l-1.802-1.802-.177-.176-.177.176-.5.502-.178.177.177.176 1.802 1.802-1.802 1.802-.177.177.177.177.502.501.176.177.177-.177 1.802-1.802 1.802 1.802.177.177.177-.177.5-.501.178-.177-.177-.177-1.802-1.802z"></path></svg></div>';
        } catch (k) {
          console.error("Error occurred during fetch or parsing JSON:", k);
        } finally {
          s.remove();
        }
      },
    };
    (this.calendar = flatpickr(t, a)),
      (e.querySelector(".flatpickr-input").style.display = "none");
  },
}.init();
